<!--
 * @Author: 罗川平 2150673512@qq.com
 * @Date: 2026-03-26 14:57:26
 * @LastEditors: 罗川平 2150673512@qq.com
 * @LastEditTime: 2026-07-14 15:50:11
 * @FilePath: \watherfocast2\src\views\HomeView.vue
 * @Description: 首页 - 风电预测平台
-->
<template>
  <div class="homeViewBody" :class="{ 'light-theme': currentTheme === 'light' }">
    <div class="homeViewHeader">
      海陆多场景集群风电精细化功率预报平台
      <div class="timeBox">
        {{ currentTime }}
      </div>
      <div class="locBox"></div>
      <div class="theme-toggle" @click="toggleTheme">
        <i :class="currentTheme === 'dark' ? 'el-icon-cloudy-and-sunny' : 'el-icon-moon'"></i>
        {{ currentTheme === 'dark' ? '亮色' : '暗黑' }}
      </div>
    </div>
    <div class="myheaderBtnBox">
       <div class="myheaderBtnitem"></div>
       <div class="myheaderBtnitem"></div>
       <div class="myheaderBtnitem"></div>
      <!-- <div class="myheaderBtnitem">首页</div>
      <div class="myheaderBtnitem" @click="goToStatistics">统计查询</div>
      <div class="myheaderBtnitem" @click="goToPrediction">预测分析</div> -->
      <div class="myheaderBtnitem user-menu" @click="handleLogout">
        <i class="el-icon-user-solid"></i>
        退出登录
      </div>
    </div>
    <div class="homeMainBox">
      <div class="mainLayout">
        <!-- 左侧区域 -->
        <div class="leftColumn">
          <!-- 模型与时间选择 -->
          <div class="card overview-card">
            <dv-border-box-8>
              <div class="chart-container">
                <div class="chart-title">参数选择</div>
                <div class="filter-form">
                  <div class="form-item">
                    <span class="form-label">模型选择</span>
                    <el-select 
                      v-model="selectedModel" 
                      class="form-select"
                      placeholder="请选择模型"
                    >
                      <el-option 
                        v-for="model in modelOptions" 
                        :key="model.value" 
                        :label="model.label" 
                        :value="model.value"
                      />
                    </el-select>
                  </div>
                  <div class="form-item">
                    <span class="form-label">预测时间</span>
                    <el-date-picker
                      v-model="scTime"
                      type="datetime"
                      placeholder="选择时间"
                      class="form-date"
                      value-format="yyyy-MM-dd HH:mm:ss"
                    />
                  </div>
                  <div class="form-item">
                    <span class="form-label">开始时间</span>
                    <el-date-picker
                      v-model="startTime"
                      type="datetime"
                      placeholder="选择时间"
                      class="form-date"
                      value-format="yyyy-MM-dd HH:mm:ss"
                    />
                  </div>
                  <div class="form-item">
                    <span class="form-label">结束时间</span>
                    <el-date-picker
                      v-model="endTime"
                      type="datetime"
                      placeholder="选择时间"
                      class="form-date"
                      value-format="yyyy-MM-dd HH:mm:ss"
                    />
                  </div>
                  <div class="form-item">
                    <el-button type="primary" @click="handleQuery" class="form-btn">
                      查询
                    </el-button>
                  </div>
                </div>
              </div>
            </dv-border-box-8>
          </div>
          <!-- 功率趋势图 -->
          <div class="card">
            <dv-border-box-8>
              <div class="chart-container">
                <div class="chart-title">风能与功率预测对比</div>
                <div class="chart-content" ref="trendChart"></div>
              </div>
            </dv-border-box-8>
          </div>
          <!-- 实况与预测风能对比 -->
          <div class="card">
            <dv-border-box-8>
              <div class="chart-container">
                <div class="chart-title">实况与预测风能对比</div>
                <div class="chart-content" ref="windEnergyChart"></div>
              </div>
            </dv-border-box-8>
          </div>
        </div>

        <!-- 中间区域 -->
        <div class="centerColumn">
          <div class="card">
            <dv-border-box-8>
              <div class="chart-container" style="padding:0;">
                <div class="wind-layer-toggle">
                  <button 
                    :class="['toggle-btn', { active: windLayerMode === 'velocity' }]"
                    @click="switchWindLayer('velocity')"
                  >流体风场</button>
                  <button 
                    :class="['toggle-btn', { active: windLayerMode === 'grid' }]"
                    @click="switchWindLayer('grid')"
                  >风速格点</button>
                </div>
                <div id="pvMap" class="map-chart"></div>
                <div v-if="windLayerMode === 'grid' && windSpeedFrames.length" class="wind-speed-player">
                  <button class="toggle-btn" :disabled="windSpeedFrameIdx <= 0" @click="windSpeedPrev">⏮</button>
                  <button class="toggle-btn" @click="windSpeedTogglePlay">{{ windSpeedPlaying ? '⏸' : '▶' }}</button>
                  <button class="toggle-btn" :disabled="windSpeedFrameIdx >= windSpeedFrames.length - 1" @click="windSpeedNext">⏭</button>
                  <span class="player-info">
                    {{ windSpeedFrameIdx + 1 }}/{{ windSpeedFrames.length }}
                    <span v-if="windSpeedFrames[windSpeedFrameIdx]">&nbsp;{{ windSpeedFrames[windSpeedFrameIdx].timeStr }}</span>
                  </span>
                </div>
              </div>
            </dv-border-box-8>
          </div>
          <!-- 未来十天功率预测 -->
          <div class="card" style="flex:0 0 220px;">
            <dv-border-box-8>
              <div class="chart-container">
                <div class="chart-title">未来一天功率预测</div>
                <div class="chart-content" ref="forecastChart"></div>
              </div>
            </dv-border-box-8>
          </div>
        </div>

        <!-- 右侧区域 -->
        <div class="rightColumn">
          <!-- 发电概况 -->
          <div class="card overview-card">
            <dv-border-box-8>
              <div class="chart-container">
                <div class="chart-title">发电概况</div>
                <div class="overview-grid">
                  <div class="overview-item">
                    <div class="overview-value">{{ powerData.currPower }}<span class="unit"> MW</span></div>
                    <div class="overview-label">当前功率</div>
                  </div>
                  <div class="overview-item">
                    <div class="overview-value">{{ powerData.dailyGen }}<span class="unit"> MWh</span></div>
                    <div class="overview-label">今日发电</div>
                  </div>
                  <div class="overview-item">
                    <div class="overview-value">{{ powerData.efficiency }}<span class="unit">%</span></div>
                    <div class="overview-label">转换效率</div>
                  </div>
                  <div class="overview-item">
                    <div class="overview-value">{{ powerData.co2 }}<span class="unit"> t</span></div>
                    <div class="overview-label">减排CO₂</div>
                  </div>
                </div>
              </div>
            </dv-border-box-8>
          </div>
          <!-- 发电功率图表 -->
          <div class="card">
            <dv-border-box-8>
              <div class="chart-container">
                <div class="chart-title">实况与预报功率对比</div>
                <div class="chart-content" ref="powerChart"></div>
              </div>
            </dv-border-box-8>
          </div>
          <!-- 电站排名表 -->
          <div class="card">
            <dv-border-box-8>
              <div class="chart-container">
                <div class="chart-title">功率排名</div>
                <div class="chart-content table-wrap">
                  <table class="data-table">
                    <thead>
                      <tr>
                        <th>#</th>
                        <th>电站</th>
                        <th>功率(MW)</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(item, index) in powerRankList" :key="index">
                        <td>{{ index + 1 }}</td>
                        <td>{{ item.name }}</td>
                        <td>{{ item.power }}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </dv-border-box-8>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { MapCreate, L } from '../map/mapImport.js'
import * as echarts from 'echarts'
import axios from 'axios'
import WindDecoder from '@/utils/windDecoder'
import { createWindVelocityLayer } from '@/utils/windFieldLayer'
import { parseGrayscalePNG } from '@/utils/imageParser'

export default {
  name: 'HomeView',
  data() {
    return {
      currentTime: '',
      currentTheme: 'dark',
      mapData: null,
      gridDataLayer: null,
      gridData: [],
      trendChartInstance: null,
      powerChartInstance: null,
      forecastChartInstance: null,
      windEnergyChartInstance: null,
      powerCompareData: [],
      forecastData: [],
      windDecoder: null,
      windLayerMode: 'velocity',
      // 风速格点播放
      windSpeedFrames: [],       // [{flatData, timeStr}]
      windSpeedFrameIdx: 0,
      windSpeedPlaying: false,
      windSpeedTimer: null,
      windGridItem: null,
      selectedModel: 'gbrt',
      modelOptions: [
        { label: '随机森林', value: 'gbrt' },
        { label: '长短时记忆网络', value: 'lstm' }
      ],
      forecastApiMap: {
        gbrt: 'https://moodsci.com/lsserver/wind/forcast/windPredictedPowerGbrt',
        lstm: 'https://moodsci.com/lsserver/wind/forcast/windPredictedPowerLstm'
      },
      scTime: this._formatDateTime(new Date(Date.now() - 3 * 60 * 60 * 1000)),
      startTime: this._formatDateTime(new Date()),
      endTime: this._formatDateTime(new Date(Date.now() + 24 * 60 * 60 * 1000)),
      powerData: {
        currPower: '42.8',
        dailyGen: '286.5',
        efficiency: '18.2',
        co2: '142.3'
      },
      powerRankList: [
        { name: '达坂城风场', power: '52.8' },
        { name: '酒泉风场', power: '48.6' },
        { name: '哈密风场', power: '43.2' },
        { name: '张北风场', power: '38.5' },
        { name: '通辽风场', power: '35.1' }
      ],
      overviewData: {
        stationCount: 85,
        avgWindSpeed: '8.6',
        maxWindSpeed: '18.3',
        power: '95.2'
      }
    }
  },
  mounted() {
    this.updateTime()
    this.initMap()
    this.decodeWindImage()
    // this.fetchGridData()
    this.$nextTick(() => {
      this.initTrendChart()
      this.initPowerChart()
      this.initForecastChart()
      this.initWindEnergyChart()
    })
    this.fetchPowerCompareData()
    this.fetchForecastData()
    setInterval(() => {
      this.updateTime()
    }, 1000)
    window.addEventListener('resize', this.handleResize)
  },
  beforeDestroy() {
    if (this.mapData && this.mapData.map) {
      this.mapData.map.remove()
      this.mapData = null
    }
    this.clearGridData()
    if (this.trendChartInstance) {
      this.trendChartInstance.dispose()
      this.trendChartInstance = null
    }
    if (this.powerChartInstance) {
      this.powerChartInstance.dispose()
      this.powerChartInstance = null
    }
    if (this.forecastChartInstance) {
      this.forecastChartInstance.dispose()
      this.forecastChartInstance = null
    }
    if (this.windEnergyChartInstance) {
      this.windEnergyChartInstance.dispose()
      this.windEnergyChartInstance = null
    }
    window.removeEventListener('resize', this.handleResize)
  },
  methods: {
    initMap() {
      this.mapData = new MapCreate()
      const map = this.mapData.init('pvMap')
      this._addWindFarmMarkers(map)
    },
    _addWindFarmMarkers(map) {
      const windIcon = L.icon({
        iconUrl: require('@/assets/map/windIcona.png'),
        iconSize: [32, 32],
        iconAnchor: [16, 16],
        popupAnchor: [0, -16]
      })

      const windFarms = [
        { name: '达坂城风电场', lat: 43.35, lng: 88.32, power: 500, desc: '亚洲最大风电场之一' },
        { name: '哈密东南部风电场', lat: 42.82, lng: 93.52, power: 200, desc: '千万千瓦级风电基地' },
        { name: '酒泉风电场', lat: 39.75, lng: 98.50, power: 380, desc: '世界最大风电基地' },
        { name: '张北风电场', lat: 41.15, lng: 114.70, power: 300, desc: '国家风光储输示范基地' },
        { name: '通辽风电场', lat: 43.62, lng: 122.27, power: 150, desc: '内蒙古东部风电基地' },
        { name: '海南州风电', lat: 36.29, lng: 100.62, power: 120, desc: '青海风电基地' },
        { name: '阿勒泰风电场', lat: 47.85, lng: 88.13, power: 100, desc: '新疆北部优质风场' }
      ]

      windFarms.forEach((farm) => {
        const marker = L.marker([farm.lat, farm.lng], { icon: windIcon })

        marker.bindPopup(`
          <div style="font-size:13px;line-height:1.6;">
            <b style="color:#00d8ff;font-size:15px;">${farm.name}</b><br/>
            <span style="color:#666;">装机容量: <b style="color:#333;">${farm.power} MW</b></span><br/>
            <span style="color:#999;">${farm.desc}</span>
          </div>
        `)

        marker.bindTooltip(farm.name, {
          direction: 'top',
          offset: [0, -8],
          className: 'wind-farm-tooltip'
        })

        marker.addTo(map)
        this._windFarmMarkers = this._windFarmMarkers || []
        this._windFarmMarkers.push(marker)
      })
    },
    initTrendChart() {
      const dom = this.$refs.trendChart
      if (!dom) return
      this.trendChartInstance = echarts.init(dom)
      const hours = ['08:00', '09:00', '10:00', '11:00', '12:00', '13:00', '14:00', '15:00', '16:00', '17:00', '18:00']
      const option = {
        tooltip: { trigger: 'axis' },
        legend: {
          bottom: 0,
          textStyle: { color: '#999', fontSize: 10 },
          data: ['风能', '功率预测']
        },
        grid: { left: 45, right: 45, top: 20, bottom: 35 },
        xAxis: {
          type: 'category',
          data: hours,
          axisLabel: { color: '#999', fontSize: 10, rotate: 30 },
          axisLine: { lineStyle: { color: 'rgba(0,216,255,0.3)' } }
        },
        yAxis: [
          {
            type: 'value',
            name: 'MW·h',
            splitLine: { lineStyle: { color: 'rgba(0,216,255,0.1)' } },
            axisLabel: { color: '#999', fontSize: 10 }
          },
          {
            type: 'value',
            name: 'MW',
            splitLine: { show: false },
            axisLabel: { color: '#999', fontSize: 10 }
          }
        ],
        series: [
          {
            name: '风能',
            type: 'bar',
            barWidth: 12,
            itemStyle: {
              borderRadius: [3, 3, 0, 0],
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                { offset: 0, color: 'rgba(0,216,255,0.9)' },
                { offset: 1, color: 'rgba(0,216,255,0.15)' }
              ])
            },
            data: [12.5, 28.6, 45.2, 62.8, 78.5, 85.3, 76.8, 58.4, 38.2, 22.6, 8.5]
          },
          {
            name: '功率预测',
            type: 'line',
            yAxisIndex: 1,
            smooth: true,
            symbol: 'circle',
            symbolSize: 5,
            lineStyle: { color: '#f9ca24', width: 2 },
            itemStyle: { color: '#f9ca24' },
            data: [18.5, 39.8, 56.2, 75.3, 88.6, 95.1, 85.2, 68.5, 48.6, 32.5, 12.8]
          }
        ]
      }
      this.trendChartInstance.setOption(option)
    },
    handleResize() {
      if (this.trendChartInstance) {
        this.trendChartInstance.resize()
      }
      if (this.powerChartInstance) {
        this.powerChartInstance.resize()
      }
      if (this.forecastChartInstance) {
        this.forecastChartInstance.resize()
      }
      if (this.windEnergyChartInstance) {
        this.windEnergyChartInstance.resize()
      }
    },
    initPowerChart() {
      const dom = this.$refs.powerChart
      if (!dom) return
      this.powerChartInstance = echarts.init(dom)

      let xData, actualData, predictedData

      if (this.powerCompareData && this.powerCompareData.length > 0) {
        xData = this.powerCompareData.map(item => {
          const date = new Date(item.preTime)
          return `${String(date.getHours()).padStart(2, '0')}:${String(date.getMinutes()).padStart(2, '0')}`
        })
        actualData = this.powerCompareData.map(item => item.actualPower)
        predictedData = this.powerCompareData.map(item => item.predictedPower)
      } else {
        xData = ['08:00', '09:00', '10:00', '11:00', '12:00', '13:00', '14:00', '15:00', '16:00', '17:00', '18:00']
        actualData = [22.8, 42.5, 58.2, 76.8, 88.3, 95.6, 90.2, 78.5, 60.8, 38.2, 15.6]
        predictedData = [20.5, 39.8, 56.5, 73.2, 86.5, 92.8, 87.5, 75.2, 58.5, 35.8, 13.2]
      }

      const option = {
        tooltip: { trigger: 'axis' },
        legend: {
          bottom: 0,
          textStyle: { color: '#999', fontSize: 10 },
          data: ['实况功率', '预报功率']
        },
        grid: { left: 40, right: 20, top: 20, bottom: 35 },
        xAxis: {
          type: 'category',
          data: xData,
          axisLabel: { color: '#999', fontSize: 10, rotate: 30 },
          axisLine: { lineStyle: { color: 'rgba(0,216,255,0.3)' } }
        },
        yAxis: {
          type: 'value',
          name: 'MW',
          splitLine: { lineStyle: { color: 'rgba(0,216,255,0.1)' } },
          axisLabel: { color: '#999', fontSize: 10 }
        },
        series: [
          {
            name: '实况功率',
            data: actualData,
            type: 'line',
            smooth: true,
            symbol: 'circle',
            symbolSize: 5,
            lineStyle: { color: '#00d8ff', width: 2 },
            itemStyle: { color: '#00d8ff' },
            areaStyle: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                { offset: 0, color: 'rgba(0,216,255,0.25)' },
                { offset: 1, color: 'rgba(0,216,255,0.02)' }
              ])
            }
          },
          {
            name: '预报功率',
            data: predictedData,
            type: 'line',
            smooth: true,
            symbol: 'diamond',
            symbolSize: 5,
            lineStyle: { color: '#f9ca24', width: 2 },
            itemStyle: { color: '#f9ca24' }
          }
        ]
      }
      this.powerChartInstance.setOption(option)
    },
    initForecastChart() {
      const dom = this.$refs.forecastChart
      if (!dom) return
      this.forecastChartInstance = echarts.init(dom)

      let xData, predictedData

      if (this.forecastData && this.forecastData.length > 0) {
        xData = this.forecastData.map(item => {
          const date = new Date(item.preTime)
          return `${String(date.getHours()).padStart(2, '0')}:${String(date.getMinutes()).padStart(2, '0')}`
        })
        predictedData = this.forecastData.map(item => item.predictedPower)
      } else {
        xData = ['00:00', '02:00', '04:00', '06:00', '08:00', '10:00', '12:00', '14:00', '16:00', '18:00', '20:00', '22:00']
        predictedData = [85.2, 88.6, 82.4, 91.3, 78.5, 92.8, 86.1, 83.5, 87.2, 90.4, 88.1, 84.6]
      }

      const option = {
        tooltip: { 
          trigger: 'axis',
          formatter: (params) => {
            const param = params[0]
            return `${param.name}<br/>预测功率: ${param.value} MW`
          }
        },
        grid: { left: 45, right: 20, top: 15, bottom: 50 },
        xAxis: {
          type: 'category',
          data: xData,
          axisLabel: { color: '#999', fontSize: 9 },
          axisLine: { lineStyle: { color: 'rgba(0,216,255,0.3)' } },
          axisTick: { show: false }
        },
        yAxis: {
          type: 'value',
          name: 'MW',
          splitLine: { lineStyle: { color: 'rgba(0,216,255,0.1)' } },
          axisLabel: { color: '#999', fontSize: 10 }
        },
        dataZoom: [
          {
            type: 'inside',
            start: 0,
            end: 50,
            zoomOnMouseWheel: true,
            moveOnMouseMove: true
          },
          {
            type: 'slider',
            show: true,
            start: 0,
            end: 50,
            height: 18,
            bottom: 5,
            borderColor: 'rgba(0,216,255,0.3)',
            fillerColor: 'rgba(0,216,255,0.1)',
            handleStyle: {
              color: '#00d8ff'
            },
            textStyle: {
              color: '#999',
              fontSize: 10
            }
          }
        ],
        series: [
          {
            name: '预测功率',
            data: predictedData,
            type: 'line',
            smooth: true,
            symbol: 'circle',
            symbolSize: 4,
            lineStyle: {
              width: 2,
              color: '#00d8ff'
            },
            itemStyle: {
              color: '#00d8ff'
            },
            areaStyle: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                { offset: 0, color: 'rgba(0,216,255,0.3)' },
                { offset: 1, color: 'rgba(0,216,255,0.02)' }
              ])
            }
          }
        ]
      }
      this.forecastChartInstance.setOption(option)
    },
    initWindEnergyChart() {
      const dom = this.$refs.windEnergyChart
      if (!dom) return
      this.windEnergyChartInstance = echarts.init(dom)

      let xData, actualData, predictedData

      if (this.powerCompareData && this.powerCompareData.length > 0) {
        xData = this.powerCompareData.map(item => {
          const date = new Date(item.preTime)
          return `${String(date.getHours()).padStart(2, '0')}:${String(date.getMinutes()).padStart(2, '0')}`
        })
        actualData = this.powerCompareData.map(item => item.actualPower)
        predictedData = this.powerCompareData.map(item => item.predictedPower)
      } else {
        xData = ['08:00', '09:00', '10:00', '11:00', '12:00', '13:00', '14:00', '15:00', '16:00', '17:00', '18:00']
        actualData = [15.2, 35.8, 52.5, 72.3, 88.6, 96.2, 82.5, 65.8, 45.2, 28.6, 10.5]
        predictedData = [13.8, 33.5, 50.2, 68.5, 85.3, 93.8, 78.6, 62.5, 42.8, 26.2, 9.8]
      }

      const option = {
        tooltip: { trigger: 'axis' },
        legend: {
          bottom: 0,
          textStyle: { color: '#999', fontSize: 10 },
          data: ['实况风能', '预测风能']
        },
        grid: { left: 45, right: 20, top: 20, bottom: 35 },
        xAxis: {
          type: 'category',
          data: xData,
          axisLabel: { color: '#999', fontSize: 10 },
          axisLine: { lineStyle: { color: 'rgba(0,216,255,0.3)' } },
          axisTick: { show: false }
        },
        yAxis: {
          type: 'value',
          name: 'MW',
          splitLine: { lineStyle: { color: 'rgba(0,216,255,0.1)' } },
          axisLabel: { color: '#999', fontSize: 10 }
        },
        series: [
          {
            name: '实况风能',
            type: 'line',
            smooth: true,
            symbol: 'circle',
            symbolSize: 4,
            lineStyle: { width: 2, color: '#00d8ff' },
            itemStyle: { color: '#00d8ff' },
            areaStyle: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                { offset: 0, color: 'rgba(0,216,255,0.3)' },
                { offset: 1, color: 'rgba(0,216,255,0.02)' }
              ])
            },
            data: actualData
          },
          {
            name: '预测风能',
            type: 'line',
            smooth: true,
            symbol: 'diamond',
            symbolSize: 4,
            lineStyle: { width: 2, color: '#f9ca24' },
            itemStyle: { color: '#f9ca24' },
            areaStyle: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                { offset: 0, color: 'rgba(249,202,36,0.2)' },
                { offset: 1, color: 'rgba(249,202,36,0.02)' }
              ])
            },
            data: predictedData
          }
        ]
      }
      this.windEnergyChartInstance.setOption(option)
    },
    async fetchGridData() {
      try {
        const response = await axios.get('https://www.moodsci.com/lsserver/wind/data/wind', {
          params: {
            dData: '20260420',
            fData: '008',
            gdc: '1000'
          }
        })
        if (response.data && response.data.success) {
          this.gridData = response.data.data
          this.renderGridData()
        }
      } catch (error) {
        console.error('获取格点数据失败:', error)
      }
    },
    async fetchPowerCompareData() {
      try {
        const response = await axios.get('https://moodsci.com/lsserver/wind/forcast/windPowerCompare', {
          params: {
            stationId: 'CN0001',
            scTime: this.scTime,
            startTime: this.startTime,
            endTime: this.endTime
          }
        })

        if (response.data && response.data.code === 200) {
          this.powerCompareData = response.data.data
          this.refreshCharts()
        }
      } catch (error) {
        console.error('获取功率对比数据失败:', error)
      }
    },
    async handleQuery() {
      await this.fetchPowerCompareData()
      await this.fetchForecastData()
      if (this.windLayerMode === 'velocity') {
        this.decodeWindImage()
      } else {
        this._renderWindSpeedGrid()
      }
    },
    async fetchForecastData() {
      try {
        const apiUrl = this.forecastApiMap[this.selectedModel] || this.forecastApiMap.gbrt
        const response = await axios.get(apiUrl, {
          params: {
            stationId: 'CN0001',
            scTime: this.scTime,
            startTime: this.startTime,
            endTime: this.endTime
          }
        })
        if (response.data && response.data.code === 200) {
          this.forecastData = response.data.data
          this.refreshForecastChart()
        }
      } catch (error) {
        console.error('获取预测数据失败:', error)
      }
    },
    refreshCharts() {
      if (this.powerChartInstance) {
        this.powerChartInstance.dispose()
      }
      if (this.windEnergyChartInstance) {
        this.windEnergyChartInstance.dispose()
      }
      this.initPowerChart()
      this.initWindEnergyChart()
    },
    refreshForecastChart() {
      if (this.forecastChartInstance) {
        this.forecastChartInstance.dispose()
      }
      this.initForecastChart()
    },
    async decodeWindImage() {
      try {
        const decoder = new WindDecoder()
        // 根据操作面板预测时间构造URL: {yyyymm}/WIND_DUAL_f{hhh}.png
        const t = new Date(this.scTime)
        const yyyymmdd = `${t.getFullYear()}${String(t.getMonth() + 1).padStart(2, '0')}${String(t.getDate()).padStart(2, '0')}`
        const fhour = String(t.getHours()).padStart(3, '0')
        const url = `https://forecast-1303702531.cos.ap-chengdu.myqcloud.com/gfs/img/WIND_DUAL/${yyyymmdd}/WIND_DUAL_f${fhour}.png`
        console.log('风场图片URL:', url)
        const result = await decoder.decodeFromUrl(url)
        this.windDecoder = decoder
        console.log('风场解码完成:', result)
        decoder.printData()
        this._addWindFieldLayer()
        return result
      } catch (error) {
        console.error('风场图片解码失败:', error)
      }
    },
    _addWindFieldLayer() {
      if (!this.windDecoder || !this.mapData || !this.mapData.map) return
      if (this._windFieldLayer) {
        this.mapData.map.removeLayer(this._windFieldLayer)
        this._windFieldLayer = null
      }
      if (this._windGridLayer) {
        this.mapData.map.removeLayer(this._windGridLayer)
        this._windGridLayer = null
      }
      // 根据当前模式显示对应图层
      if (this.windLayerMode === 'velocity') {
        this._windFieldLayer = createWindVelocityLayer(
          this.windDecoder,
          this.mapData.map,
          { maxVelocity: 25, opacity: 0.92 }
        )
      } else {
        // 风速格点
        this._renderWindSpeedGrid()
      }
      console.log('风场图层已切换: ' + this.windLayerMode)
    },
    switchWindLayer(mode) {
      if (this.windLayerMode === mode) return
      this.windLayerMode = mode
      if (mode === 'velocity') {
        this.decodeWindImage()
      } else {
        if (this._windFieldLayer) {
          this.mapData.map.removeLayer(this._windFieldLayer)
          this._windFieldLayer = null
        }
        if (this._windGridLayer) {
          this.mapData.map.removeLayer(this._windGridLayer)
          this._windGridLayer = null
        }
        this._renderWindSpeedGrid()
      }
    },
    async _renderWindSpeedGrid() {
      // 先停止之前的播放
      this._windSpeedStop()
      // 加载开始时间~结束时间之间所有小时帧
      await this._loadWindSpeedFrames()
      if (this.windSpeedFrames.length > 0) {
        this._showWindSpeedFrame(0)
      }
    },
    async _loadWindSpeedFrames() {
      const start = new Date(this.startTime)
      const end = new Date(this.endTime)
      const frames = []
      const map = this.mapData.map

      // 色阶
      const opacity = 0.7
      const gradient = [
        [0, [49, 54, 149, opacity]],
        [4, [69, 117, 180, opacity]],
        [8, [116, 173, 209, opacity]],
        [12, [171, 217, 233, opacity]],
        [16, [224, 243, 248, opacity]],
        [20, [255, 255, 191, opacity]],
        [24, [254, 224, 144, opacity]],
        [28, [253, 174, 97, opacity]],
        [32, [244, 109, 67, opacity]],
        [36, [215, 48, 39, opacity]],
        [40, [174, 25, 29, opacity]]
      ]

      // 构造每个小时的URL并加载
      for (let t = new Date(start); t <= end; t.setHours(t.getHours() + 1)) {
        const yyyymmdd = `${t.getFullYear()}${String(t.getMonth() + 1).padStart(2, '0')}${String(t.getDate()).padStart(2, '0')}`
        const fhour = String(t.getHours()).padStart(3, '0')
        const url = `https://forecast-1303702531.cos.ap-chengdu.myqcloud.com/gfs/img/UVSpeed/${yyyymmdd}/UVSpeed_f${fhour}.png`
        const timeStr = `${String(t.getMonth() + 1).padStart(2, '0')}-${String(t.getDate()).padStart(2, '0')} ${String(t.getHours()).padStart(2, '0')}:00`

        try {
          const parsed = await parseGrayscalePNG(url)
          const flatData = new Float32Array(parsed.width * parsed.height)
          for (let r = 0; r < parsed.height; r++) {
            for (let c = 0; c < parsed.width; c++) {
              flatData[r * parsed.width + c] = parsed.data[r][c]
            }
          }
          frames.push({ flatData, timeStr, parsed, url, gradient })
        } catch (e) {
          console.warn(`风速帧加载失败 ${url}:`, e.message)
        }
      }

      this.windSpeedFrames = frames
      this.windGridItem = {
        left: 70,
        top: 70,
        right: 140,
        bottom: 0,
        cols: 281,
        rows: 281
      }
      console.log(`风速格点: 加载了 ${frames.length} 帧 (${start.toLocaleString()} ~ ${end.toLocaleString()})`)
    },
    _showWindSpeedFrame(idx) {
      if (!this.windGridItem || idx < 0 || idx >= this.windSpeedFrames.length) return
      const frame = this.windSpeedFrames[idx]
      const map = this.mapData.map

      const newLayer = L.tilePixelLayer({
        newData: frame.flatData,
        data: this.windGridItem,
        gradient: frame.gradient || [
          [0, [49, 54, 149, 0.7]],
          [4, [69, 117, 180, 0.7]],
          [8, [116, 173, 209, 0.7]],
          [12, [171, 217, 233, 0.7]],
          [16, [224, 243, 248, 0.7]],
          [20, [255, 255, 191, 0.7]],
          [24, [254, 224, 144, 0.7]],
          [28, [253, 174, 97, 0.7]],
          [32, [244, 109, 67, 0.7]],
          [36, [215, 48, 39, 0.7]],
          [40, [174, 25, 29, 0.7]]
        ],
        clickEvt: (e, gridValue) => {
          L.popup({ autoPanPaddingBottomRight: L.point(600, 0) })
            .setLatLng([e.latlng.lat, e.latlng.lng])
            .setContent(`<div>风速: ${gridValue != null ? gridValue.toFixed(1) : '-'} m/s<br/>${frame.timeStr}</div>`)
            .openOn(map)
        }
      })

      // 先加新图层，再删旧图层，避免闪屏
      newLayer.addTo(map)
      const oldLayer = this._windGridLayer
      this._windGridLayer = newLayer
      if (oldLayer) {
        setTimeout(() => map.removeLayer(oldLayer), 300)
      }
      this.windSpeedFrameIdx = idx
    },
    _windSpeedPlay() {
      if (!this.windSpeedFrames.length) return
      this._windSpeedStop()
      this.windSpeedPlaying = true
      // 从当前帧开始播放
      if (this.windSpeedFrameIdx >= this.windSpeedFrames.length - 1) {
        this.windSpeedFrameIdx = -1
      }
      const step = () => {
        if (!this.windSpeedPlaying) return
        this.windSpeedFrameIdx++
        if (this.windSpeedFrameIdx >= this.windSpeedFrames.length) {
          this.windSpeedPlaying = false
          return
        }
        this._showWindSpeedFrame(this.windSpeedFrameIdx)
        this.windSpeedTimer = setTimeout(step, 1000)
      }
      step()
    },
    _windSpeedStop() {
      this.windSpeedPlaying = false
      if (this.windSpeedTimer) {
        clearTimeout(this.windSpeedTimer)
        this.windSpeedTimer = null
      }
    },
    windSpeedTogglePlay() {
      if (this.windSpeedPlaying) {
        this._windSpeedStop()
      } else {
        this._windSpeedPlay()
      }
    },
    windSpeedPrev() {
      this._windSpeedStop()
      if (this.windSpeedFrameIdx > 0) {
        this._showWindSpeedFrame(this.windSpeedFrameIdx - 1)
      }
    },
    windSpeedNext() {
      this._windSpeedStop()
      if (this.windSpeedFrameIdx < this.windSpeedFrames.length - 1) {
        this._showWindSpeedFrame(this.windSpeedFrameIdx + 1)
      }
    },
    renderGridData() {
      if (!this.mapData || !this.mapData.map || !this.gridData.length) return
      
      this.clearGridData()
      
      const gridItem = this.gridData[0]
      if (!gridItem) return
      
      const dataStr = gridItem['windspeed']
      if (!dataStr) return

      const dataArray = dataStr.split(',').map(item => Number(item))

      const opacity = 0.6
      const ledcolorList = [
        [0, [49, 54, 149, opacity]],
        [3, [69, 117, 180, opacity]],
        [6, [116, 173, 209, opacity]],
        [9, [171, 217, 233, opacity]],
        [12, [224, 243, 248, opacity]],
        [15, [255, 255, 191, opacity]],
        [18, [254, 224, 144, opacity]],
        [21, [253, 174, 97, opacity]],
        [24, [244, 109, 67, opacity]],
        [27, [215, 48, 39, opacity]],
        [30, [174, 25, 29, opacity]]
      ]
      console.log(dataArray);
      
      this.gridDataLayer = L.tilePixelLayer({
        newData: dataArray,
        data: gridItem,
        gradient: ledcolorList,
        clickEvt: (e, gridValue) => {
          let popup = L.popup({
            autoPanPaddingBottomRight: L.point(600, 0)
          })
            .setLatLng([e.latlng.lat, e.latlng.lng])
            .setContent(`<div>风速:${gridValue} m/s</div>`)
            .openOn(this.mapData.map)
        }
      })
      
      this.gridDataLayer.addTo(this.mapData.map)
      
      this.mapData.map.fitBounds([
        [gridItem.bottom, gridItem.left],
        [gridItem.top, gridItem.right]
      ])
    },
    getColorByValue(value) {
      if (value < 10) return '#313695'
      if (value < 20) return '#4575b4'
      if (value < 30) return '#74add1'
      if (value < 40) return '#abd9e9'
      if (value < 50) return '#e0f3f8'
      if (value < 60) return '#ffffbf'
      if (value < 70) return '#fee090'
      if (value < 80) return '#fdae61'
      if (value < 90) return '#f46d43'
      return '#d73027'
    },
    clearGridData() {
      if (this.gridDataLayer && this.mapData && this.mapData.map) {
        this.mapData.map.removeLayer(this.gridDataLayer)
        this.gridDataLayer = null
      }
    },
    _formatDateTime(date) {
      // 向下取整到整点
      const rounded = new Date(date)
      rounded.setMinutes(0, 0, 0)
      const y = rounded.getFullYear()
      const m = String(rounded.getMonth() + 1).padStart(2, '0')
      const d = String(rounded.getDate()).padStart(2, '0')
      const h = String(rounded.getHours()).padStart(2, '0')
      return `${y}-${m}-${d} ${h}:00:00`
    },
    updateTime() {
      const now = new Date()
      const year = now.getFullYear()
      const month = String(now.getMonth() + 1).padStart(2, '0')
      const day = String(now.getDate()).padStart(2, '0')
      const hours = String(now.getHours()).padStart(2, '0')
      const minutes = String(now.getMinutes()).padStart(2, '0')
      const seconds = String(now.getSeconds()).padStart(2, '0')
      const weekDays = ['星期日', '星期一', '星期二', '星期三', '星期四', '星期五', '星期六']
      const weekDay = weekDays[now.getDay()]
      this.currentTime = `${year}-${month}-${day} ${hours}:${minutes}:${seconds} ${weekDay}`
    },
    goToStatistics() {
      this.$router.push({ name: 'Statistics' })
    },
    goToPrediction() {
      this.$router.push({ name: 'Predictive' })
    },
    toggleTheme() {
      this.currentTheme = this.currentTheme === 'dark' ? 'light' : 'dark'
      // 亮色主题切行政图, 暗色主题切卫星图
      if (this.mapData && this.mapData.switchBaseMap) {
        const mapType = this.currentTheme === 'dark' ? 'satellite' : 'normal'
        this.mapData.switchBaseMap(mapType)
      }
    },
    handleLogout() {
      this.$confirm('确定要退出登录吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        localStorage.removeItem('isLoggedIn')
        localStorage.removeItem('username')
        localStorage.removeItem('userId')
        localStorage.removeItem('stationId')
        localStorage.removeItem('hyStation')
        localStorage.removeItem('rememberedUser')
        this.$message.success('已退出登录')
        this.$router.push('/login')
      }).catch(() => {})
    }
  }
}
</script>

<style scoped>
.homeViewBody {
  height: 100vh;
  width: 100vw;
  background: linear-gradient(135deg, #080f1f 0%, #0d1a33 50%, #080f1f 100%);
  position: relative;
  overflow: hidden;
}

.homeViewHeader {
  height: 8vh;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 32px;
  font-weight: 700;
  color: #fff;
  letter-spacing: 8px;
  text-shadow: 0 0 20px rgba(0, 216, 255, 0.5);
  background: linear-gradient(135deg, rgba(0, 216, 255, 0.1) 0%, rgba(0, 100, 150, 0.1) 100%);
  border-bottom: 2px solid rgba(0, 216, 255, 0.3);
  position: relative;
}

.timeBox {
  position: absolute;
  right: 20px;
  top: 50%;
  transform: translateY(-50%);
  font-size: 16px;
  color: #00d8ff;
  letter-spacing: 2px;
}

.locBox {
  position: absolute;
  left: 20px;
  top: 50%;
  transform: translateY(-50%);
}

.theme-toggle {
  position: absolute;
  left: 20px;
  top: 50%;
  transform: translateY(-50%);
  display: flex;
  align-items: center;
  gap: 4px;
  color: #00d8ff;
  font-size: 14px;
  cursor: pointer;
  padding: 4px 12px;
  border: 1px solid rgba(0, 216, 255, 0.3);
  border-radius: 4px;
  transition: all 0.3s;
}

.theme-toggle:hover {
  background: rgba(0, 216, 255, 0.15);
  color: #fff;
}

.theme-toggle i {
  font-size: 16px;
}

.myheaderBtnBox {
  height: 30px;
  width: 500px;
  position: absolute;
  right: 0;
  top: 5vh;
  z-index: 999;
  display: flex;
  justify-content: space-between;
}

.myheaderBtnitem {
  height: 30px;
  width: 150px;
  color: #07D8FE;
  border: none;
  font-size: 18px;
  font-weight: 600;
  cursor: pointer;
  border-radius: 4px;
  line-height: 30px;
  margin-left: 15px;
}

.myheaderBtnitem:hover {
  color: #fff;
  text-shadow: 0 0 10px rgba(7, 216, 254, 0.8);
}

.user-menu {
  display: flex;
  align-items: center;
  justify-content: center;
}

.user-menu i {
  margin-right: 5px;
  font-size: 16px;
}

.filter-form {
  display: flex;
  flex-direction: column;
  gap: 15px;
  padding: 15px 10px 0;
}

.form-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.form-label {
  color: #00d8ff;
  font-size: 13px;
  font-weight: 500;
  width: 75px;
  flex-shrink: 0;
  text-align: right;
  padding-right: 10px;
}

.form-select,
.form-date {
  flex: 1;
  max-width: 180px;
}

.form-btn {
  width: 100%;
  height: 36px;
  font-size: 14px;
  font-weight: 600;
  background: linear-gradient(135deg, #00d8ff 0%, #0080ff 100%);
  border: none;
  border-radius: 4px;
}

.form-btn:hover {
  background: linear-gradient(135deg, #00d8ff 0%, #0066cc 100%);
}

.form-select :deep(.el-input__inner),
.form-date :deep(.el-input__inner) {
  background: rgba(0, 216, 255, 0.08);
  border: 1px solid rgba(0, 216, 255, 0.3);
  color: #00d8ff;
  font-size: 13px;
  height: 32px;
}

.form-select :deep(.el-input__inner:focus),
.form-date :deep(.el-input__inner:focus) {
  border-color: #00d8ff;
  box-shadow: 0 0 8px rgba(0, 216, 255, 0.3);
}

.form-select :deep(.el-select__arrow) {
  color: #00d8ff;
}

.form-date :deep(.el-date-editor--datetime) {
  width: 100%;
}

.form-date :deep(.el-date-editor--datetime .el-input__icon) {
  color: #00d8ff;
}

.homeMainBox {
  height: 92vh;
  width: 100%;
  padding: 15px;
  box-sizing: border-box;
  overflow: hidden;
}

.mainLayout {
  height: 100%;
  width: 100%;
  display: flex;
  gap: 15px;
  overflow: hidden;
}

.leftColumn,
.rightColumn {
  width: 25%;
  height: 100%;
  display: flex;
  flex-direction: column;
  gap: 15px;
  overflow: hidden;
}

.centerColumn {
  width: 50%;
  height: 100%;
  display: flex;
  flex-direction: column;
  gap: 15px;
  overflow: hidden;
}

.card {
  flex: 1;
  min-height: 0;
}

.chart-container {
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
  padding: 10px;
  box-sizing: border-box;
  position: relative;
}

.chart-title {
  color: #00d8ff;
  font-size: 16px;
  font-weight: 600;
  margin-bottom: 10px;
  padding-left: 10px;
  border-left: 4px solid #00d8ff;
}

.chart-content {
  flex: 1;
  width: 100%;
  min-height: 0;
}

.placeholder-content {
  display: flex;
  justify-content: center;
  align-items: center;
  color: rgba(0, 216, 255, 0.5);
  font-size: 18px;
  letter-spacing: 4px;
}

.map-chart {
  flex: 1;
  width: calc(100% - 20px);
  height: calc(100% - 40px);
  min-height: 200px;
  margin: 10px;
  border-radius: 4px;
  overflow: hidden;
}

/* 风场图层切换按钮 */
.wind-layer-toggle {
  position: absolute;
  top: 10px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 1000;
  display: flex;
  gap: 4px;
  background: rgba(8, 15, 31, 0.85);
  border-radius: 6px;
  padding: 4px;
  border: 1px solid rgba(0, 216, 255, 0.3);
}

.toggle-btn {
  padding: 4px 16px;
  border: none;
  border-radius: 4px;
  background: transparent;
  color: rgba(0, 216, 255, 0.7);
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s;
}

.toggle-btn:hover {
  color: #00d8ff;
}

.toggle-btn.active {
  background: rgba(0, 216, 255, 0.25);
  color: #fff;
}
.toggle-btn:disabled {
  opacity: 0.4;
  cursor: not-allowed;
}

/* 风速格点播放条 */
.wind-speed-player {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 6px 12px;
  background: rgba(8, 15, 31, 0.85);
  border-top: 1px solid rgba(0, 216, 255, 0.2);
}
.player-info {
  font-size: 12px;
  color: #00d4ff;
  font-family: monospace;
  min-width: 160px;
  text-align: center;
}

.light-theme .wind-layer-toggle {
  background: rgba(255, 255, 255, 0.85);
  border-color: rgba(0, 140, 200, 0.3);
}

.light-theme .toggle-btn {
  color: rgba(0, 140, 200, 0.7);
}

.light-theme .toggle-btn:hover {
  color: #0088cc;
}

.light-theme .toggle-btn.active {
  background: rgba(0, 140, 200, 0.2);
  color: #1a3a5c;
}
.map-chart >>> .leaflet-control-attribution {
  display: none;
}

/* 风场标记 tooltip */
.wind-farm-tooltip {
  background: rgba(8, 15, 31, 0.9) !important;
  border: 1px solid #00d8ff !important;
  color: #00d8ff !important;
  font-size: 12px !important;
  padding: 2px 8px !important;
  border-radius: 4px !important;
  box-shadow: 0 0 8px rgba(0, 216, 255, 0.3) !important;
}

.light-theme .wind-farm-tooltip {
  background: rgba(255, 255, 255, 0.9) !important;
  border-color: #0088cc !important;
  color: #0088cc !important;
  box-shadow: 0 0 8px rgba(0, 136, 204, 0.3) !important;
}

.overview-card {
  flex: 0 0 auto !important;
}

.overview-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 12px;
  padding: 10px 0;
}

.overview-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 12px 8px;
  background: rgba(0, 216, 255, 0.05);
  border: 1px solid rgba(0, 216, 255, 0.15);
  border-radius: 6px;
}

.overview-value {
  font-size: 22px;
  font-weight: 700;
  color: #00d8ff;
  line-height: 1.2;
}

.overview-value .unit {
  font-size: 12px;
  font-weight: 400;
  opacity: 0.7;
}

.overview-label {
  font-size: 12px;
  color: rgba(255, 255, 255, 0.6);
  margin-top: 4px;
}

/* 数据表格 */
.table-wrap {
  overflow: auto;
}

.data-table {
  width: 100%;
  border-collapse: collapse;
}

.data-table thead th {
  padding: 8px 6px;
  font-size: 12px;
  font-weight: 600;
  color: #00d8ff;
  text-align: left;
  border-bottom: 1px solid rgba(0, 216, 255, 0.3);
  position: sticky;
  top: 0;
  background: rgba(8, 15, 31, 0.95);
}

.data-table tbody td {
  padding: 7px 6px;
  font-size: 12px;
  color: rgba(255, 255, 255, 0.85);
  border-bottom: 1px solid rgba(0, 216, 255, 0.08);
}

.data-table tbody tr:hover {
  background: rgba(0, 216, 255, 0.08);
}

.data-table tbody tr:nth-child(even) {
  background: rgba(0, 216, 255, 0.03);
}

.data-table tbody td:first-child {
  color: #00d8ff;
}

/* ========== 亮色主题 ========== */
.light-theme {
  background: linear-gradient(135deg, #e8f4fd 0%, #f5f7fa 50%, #e8f4fd 100%);
}

.light-theme .homeViewHeader {
  color: #1a3a5c;
  text-shadow: 0 0 20px rgba(0, 140, 200, 0.3);
  background: linear-gradient(135deg, rgba(0, 140, 200, 0.08) 0%, rgba(0, 80, 120, 0.08) 100%);
  border-bottom: 2px solid rgba(0, 140, 200, 0.3);
}

.light-theme .timeBox {
  color: #0088cc;
}

.light-theme .theme-toggle {
  color: #0088cc;
  border-color: rgba(0, 140, 200, 0.3);
}

.light-theme .theme-toggle:hover {
  background: rgba(0, 140, 200, 0.15);
  color: #1a3a5c;
}

.light-theme .chart-title {
  color: #0088cc;
  border-left-color: #0088cc;
}

.light-theme .filter-form .form-label {
  color: #333;
}

.light-theme .filter-form :deep(.el-input__inner),
.light-theme :deep(.el-input__inner) {
  background: #fff;
  border-color: #dcdfe6;
  color: #333;
}

.light-theme .filter-form :deep(.el-input__inner:focus),
.light-theme :deep(.el-input__inner:focus) {
  border-color: #0088cc;
  box-shadow: 0 0 8px rgba(0, 140, 200, 0.2);
}

.light-theme :deep(.el-select__arrow),
.light-theme :deep(.el-input__icon) {
  color: #0088cc;
}

.light-theme .data-table thead th {
  color: #0088cc;
  background: rgba(255, 255, 255, 0.95);
  border-bottom-color: rgba(0, 140, 200, 0.3);
}

.light-theme .data-table tbody td {
  color: #333;
  border-bottom-color: rgba(0, 140, 200, 0.08);
}

.light-theme .data-table tbody tr:hover {
  background: rgba(0, 140, 200, 0.06);
}

.light-theme .data-table tbody tr:nth-child(even) {
  background: rgba(0, 140, 200, 0.02);
}

.light-theme .overview-label {
  color: #666;
}

.light-theme .placeholder-content {
  color: rgba(0, 140, 200, 0.5);
}

.light-theme .myheaderBtnitem {
  color: #0088cc;
}

.light-theme .myheaderBtnitem:hover {
  color: #1a3a5c;
  text-shadow: 0 0 10px rgba(0, 140, 200, 0.4);
}
</style>